import { schemes, zSchema } from "@zeal/common";

export const updatePartnerInfoRequestSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  business_name: zSchema.string(),
  dba: zSchema.string(),
  business_description: zSchema.string(),
  legal_structure: zSchema.string(),
  business_ein: zSchema.string(),
  business_address: zSchema.string(),
  business_address_line2: zSchema.string(),
  business_city: zSchema.string(),
  business_state: zSchema.string(),
  business_zip: zSchema.string(),
  business_phone: zSchema.string(),
  business_email: zSchema.string(),
  is_mailing_address_different: zSchema.boolean(),
  mail_address: zSchema.string(),
  mail_address_line2: zSchema.string(),
  mail_city: zSchema.string(),
  mail_state: zSchema.string(),
  mail_zip: zSchema.string(),
  is_physical_address_different: zSchema.boolean(),
  physical_address: zSchema.string(),
  physical_address_line2: zSchema.string(),
  physical_city: zSchema.string(),
  physical_state: zSchema.string(),
  physical_zip: zSchema.string(),
});

export type TUpdatePartnerInfoRequest = zSchema.infer<
  typeof updatePartnerInfoRequestSchema
>;

export type TUpdatePartnerInfoResponse = zSchema.infer<
  typeof updatePartnerInfoRequestSchema
>;
